import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  getPracticeLocationTypes,
  addPracticeLocation,
  updatePracticeLocations,
} from '../../actions/userActions/practiceLocationAction'
import { getCities } from '../../actions/userActions/cityAction'
import { Redirect } from 'react-router-dom'
import { useLocation, useHistory } from 'react-router-dom'
import { CircularProgress, IconButton } from '@mui/material'
import HrComponent from '../reuse_components/HrComponent'
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium'
import SingleSelect from '../designSystem/SingleSelect'
import BodyLargeMedium from '../designSystem/BodyLargeMedium'
import practicelocationicon from "../../assets/images/practicelocationicon.svg";
import closeModal from "../../assets/images/closeModal.svg";
import TextField from '../designSystem/TextField'
import { validateFields } from '../../utils/Validations'
function AddPracticeLocations({ onClose, editData,onSave }) {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const initialValues = {
    name: '',
    type: '',
    address: '',
    city: '',
  }
  const [loading, setLoading] = useState(true); // Loading state
  const [formValues, setFormValues] = useState(initialValues)
  const [formErrors, setFormErrors] = useState({})
   const [cityFilters, setCityFilters] = useState({
    textSearch: '',
    countryId: '1',
  })
  const cityBody = {
    filter: cityFilters,
    pageNumber: -1,
    pageSize: 0,
  }
  const allCities = useSelector((state) => state.cities_reducer.cities)
  
  const practiceLocationType = useSelector(
    (state) => state.practiceLocations_reducer.practiceLocationTypes,
  )
  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(getCities(cityBody))
        .then(() => {
          dispatch(getPracticeLocationTypes(-1));
        })
        .catch(error => {
          console.error("Error fetching data:", error);
        });
        
        if (editData) {
          setFormValues(editData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); 
      }
    };
    fetchData();
  
  }, [editData]);
  
  const handleSave = (e) => {
    e.preventDefault();
   const errors =validateFields(formValues, 'practicelocation');
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      if (editData) {
        dispatch(updatePracticeLocations(formValues));
      } else {
        dispatch(addPracticeLocation(formValues));
      }
      onSave(formValues);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormValues({ ...formValues, [name]: value })
  }

  
  const permissions = JSON.parse(localStorage.getItem('permissionsList'))
  const handleGoBack = () => {
    history.goBack();
  };
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '75vh' }}>
        <CircularProgress size={60} style={{ color: '#002D72' }} />
      </div>
    );
  }
 
  const getOptions = (type) => {
    if (type === "allCities") {
      if (
        allCities !== "isLoading" &&
        allCities.length !== 0 &&
        allCities.result?.[0]?.cities?.length !== 0
      ) {
        return allCities.result[0].cities
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((city) => ({
            value: city.id,
            label: city.name
          }));
      }
      return [];
    }

    if (type === "practiceLocationType") {
      if (
        practiceLocationType !== "isLoading" &&
        practiceLocationType.length !== 0 &&
        practiceLocationType.result &&
        practiceLocationType.result.length !== 0
      ) {
        return practiceLocationType.result
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((locationType) => ({
            value: locationType.id,
            label: locationType.name
          }));
      }
      return [];
    }

    return [];
  };
  const handletextChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleCityChange = (event) => {
    setFormValues({
        ...formValues,
        city: event.value
    })
}
const handleTypeChange = (event) => {
  setFormValues({
      ...formValues,
      type: event.value
  })
}
  return (
    <>
        <div className="dynamicmodal-overlay">
      <div className="dynamicmodal-container">
        <div className="dynamicmodal-header mb-3">
          <div className="dynamicmodal-header-left">
            <div className="icon">
              <img src={practicelocationicon} alt="practicelocationicon" />
            </div>
            <div className="text">
              <BodyLargeMedium
                text={editData ? "Edit Practice Location" : "Add Practice Location"}
                color="#384153"
              />
              <p>Specify a new practice location.</p>
            </div>
          </div>
          <div className="dynamicmodal-header-right">
          <IconButton onClick={onClose}>
            <img src={closeModal} alt="" />
            </IconButton>
          </div>
        </div>
       

        <form onSubmit={handleSave}>
          <div className="dynamicmodal-body">
        
            <div className="dynamicmodal-form-group">
            <TextField
                    label="Name"
                      type='text'
                      name='name'
                    value={formValues.name}
                    onChange={handletextChange}
                    placeholder='Enter name'
                    error={formErrors.name}
                />
            </div>
            <SingleSelect
                    label="Location Type"
                    isSearchable
                    // type="radio"
                    secondaryLabel
                    // iconStart={<Search width={16} height={16} />}
                    error={formErrors.type}
                    iconEnd
                   onChange={handleTypeChange}
                    value={formValues.type}
                    placeholder='Select type'
                    options={(practiceLocationType &&
                      practiceLocationType !== "isLoading" &&
                      practiceLocationType.length !== 0 && practiceLocationType.result &&
                      practiceLocationType.result.length !== 0)
                        && getOptions("practiceLocationType")}
                />
                <SingleSelect
                    label="City"
                    isSearchable
                    secondaryLabel
                    error={formErrors.city}
                     iconEnd
                   onChange={handleCityChange}
                    value={formValues.city}
                    placeholder='Select city'
                    options={(allCities &&
                        allCities !== "isLoading" &&
                        allCities.length !== 0 && allCities.result?.[0]?.cities &&
                        allCities.result?.[0]?.cities.length !== 0)
                        && getOptions("allCities")}
                />
            <div className="dynamicmodal-form-group">
             
            <TextField
            name='address'
                    label="Address"
                      type='text'
                    value={formValues.address}
                    onChange={handletextChange}
                    placeholder='Enter address'
                    error={formErrors.address}
                />
            </div>
           
        
          </div>

          <div className="dynamicmodal-footer">
            <button
              className="cancel-button"
              type="button"
              onClick={onClose}
            >
              <BodyExtraSmallMedium color="#1E293B" text="Cancel" />
            </button>
            <button
              type="submit"
              className="primary-button"
              disabled={false}
            >
              <BodyExtraSmallMedium color="#FFFFFF" text="Save" />
            </button>
          </div>
        </form>
      </div>
    </div>

    </>
  )
}

export default AddPracticeLocations
